var exports = {
  "J": "xaee3c4fa--bfde47--advice-list-article_decline-reason",
};

module.exports = exports;
